import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useAdminLedgerStats(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminLedgerStats() {
    setLoading(true);

    try {
      const { response, data } = await API.admin.fetchLedgerStats(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setResult(null);
        setError(data.message);
      }
    } catch (err) {
      setResult(null);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAdminLedgerStats();
  }, [token, Object.values(filters).join("__")]);

  return { loading, error, result };
}
